import { useEffect } from "react";

export function useLazyBugsnag() {
  useEffect(() => {
    if (process.env.REACT_APP_TRACK_RELEASE_STAGE !== "production") return;

    // Watch for LCP (Largest Contentful Paint)
    const observer = new PerformanceObserver((entryList, obs) => {
      const entries = entryList.getEntries();
      if (entries.length > 0) {
        // Stop observing
        obs.disconnect();

        // Wait a bit after LCP before loading Bugsnag
        setTimeout(() => {
          import("../InitBugsnag")
            .then(({ initBugsnag }) => initBugsnag())
            .catch((err) => console.error("Failed to init Bugsnag", err));
        }, 2000); // 2 seconds after LCP
      }
    });

    try {
      observer.observe({ type: "largest-contentful-paint", buffered: true });
    } catch (e) {
      console.warn("LCP observer not supported", e);
    }
  }, []);
}
